import Link from 'next/link';
import { FC } from 'react';

import PreHeading from '../PreHeading';
import BlokLink from '../StoryblokLink/BlokLink';

export interface PageGroupProps {
  title: string;
  pages: [];
  navigation: [];
}

function PageListing({ pages }) {
  return (
    <>
      {pages.map((v) => {
        return (
          <BlokLink key={v._uid} {...v} className="mb-4 block">
            <span className="max-w-48 text-base duration-200 hover:text-theme-primary hover:duration-75">
              {v.name}
            </span>
          </BlokLink>
        );
      })}
    </>
  );
}

function LinkListing({ pages }) {
  return (
    <>
      {pages.map((v) => {
        if (v.page.url) {
          return (
            <Link
              key={v._uid}
              href={v.page.url}
              className="mb-4 block max-w-48 text-base duration-200 hover:text-theme-primary hover:duration-75"
              {...v.page}
            >
              {v.label}
            </Link>
          );
        }
        return (
          <BlokLink key={v._uid} {...v.page.story} className="mb-4 block">
            <span className="max-w-48 text-base duration-200 hover:text-theme-primary hover:duration-75">
              {v.label}
            </span>
          </BlokLink>
        );
      })}
    </>
  );
}

const PageGroup: FC<PageGroupProps> = ({ pages, navigation, title }) => {
  return (
    <div>
      <div
        className={`mb-4 mt-12 sm:mt-0 ${
          title && `border-b border-white/20 pb-2`
        }`}
      >
        {title && (
          <PreHeading size="xs" color="grey">
            {title}
          </PreHeading>
        )}
      </div>
      <div className="flex flex-col gap-4">
        {pages?.length > 0 && <PageListing pages={pages} />}
        {navigation?.length > 0 && <LinkListing pages={navigation} />}
      </div>
    </div>
  );
};

export default PageGroup;
